import React, { useMemo, useState, useEffect, useRef } from "react"
import "./ManageStaff.scss"
import { useHistory } from "react-router"
import Button from "@mui/material/Button"
import { GlobalFilter } from "../../../frontDesk/patientDirectory/GlobalFilter"

import {
  deleteManageStaff,
  getAllManageStaffDetails,
  getAllManageStaffDetailsByCenterId,
  updateManageStaff,
} from "../../../../core/services/api"
import { useTable, useSortBy, useGlobalFilter } from "react-table"
//import { COLUMNS } from "./ManageStaffColumns"
import Toast from "../../../../components/Toast"
import { useSelector } from "react-redux"
import { MocUserRole } from "core/services/models/Enums"

function ManageStaff() {
  const history = useHistory()
  const [data, setData] = useState([])

  const componentRef = useRef()
  const [displayToast, toggleDisplayToast] = useState()
  // @ts-ignore
  let readOnlys = useSelector((state) => state?.user?.readOnly)
  const [isLoading, setIsLoading] = useState(false)
  // @ts-ignore
  const userDetail = useSelector((state) => state?.user?.userDetail)
  // @ts-ignore
  const userRole = useSelector((state) => state?.user?.role)

  const COLUMNS = [
    {
      Header: "MOC ID",
      accessor: "mocConsultantId",
    },
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Role",
      accessor: "primaryRole",
      // @ts-ignore
      // Cell: ({ cell }) => {
      //   // console.log('cell value', cell)
      //   let rolesName = cell?.value?.map((/** @type {any} */ item) => {
      //     return item
      //   })
      //   let str = rolesName?.join(", ")
      //   return <div style={{ textOverflow: "ellipsis" }}>{str}</div>
      // },
    },
    {
      Header: "Contact",
      accessor: "phoneNumber",
    },
    {
      Header: "Email",
      accessor: "email",
    },

    {
      Header: "",
      accessor: "Edit",
      // @ts-ignore
      Cell: ({ cell }) => {
        // @ts-ignore
        let readOnly = useSelector((state) => state?.user?.readOnly)
        if (readOnly) return null
        else {
          if (userRole === MocUserRole?.SYSTEM_ADMIN) {
            // @ts-ignore

            return (
              <img
                className="eye-icon"
                src={"assets/images/CRedit.svg"}
                width={32}
                height={30}
                style={{
                  marginTop: "6px",
                  paddingRight: "15px",
                  width: "40px",
                  height: "40px",
                }}
                alt="eye"
              />
            )
          } else {
            if (
              // @ts-ignore
              cell?.row?.original?.primaryRole === "SYSTEM_ADMIN"
            ) {
              return null
            } else {
              // @ts-ignore
              return (
                <img
                  className="eye-icon"
                  src={"assets/images/CRedit.svg"}
                  width={32}
                  height={30}
                  style={{
                    marginTop: "6px",
                    paddingRight: "15px",
                    width: "40px",
                    height: "40px",
                  }}
                  alt="eye"
                />
              )
            }
          }
        }
      },
    },

    {
      Header: "",
      accessor: "Delete",
      // @ts-ignore
      Cell: ({ cell }) => {
        // @ts-ignore
        let readOnly = useSelector((state) => state?.user?.readOnly)
        if (readOnly) return null
        else {
          if (userRole === MocUserRole?.SYSTEM_ADMIN) {
            // @ts-ignore
            if (
              // @ts-ignore
              cell?.row?.original?.primaryRole === "SYSTEM_ADMIN"
            ) {
              return null
            } else {
              return (
                <img
                  className="eye-icon"
                  src={"assets/images/CRdelete.svg"}
                  width={32}
                  height={30}
                  style={{
                    marginTop: "6px",
                    paddingRight: "15px",
                    width: "40px",
                    height: "40px",
                  }}
                  alt="eye"
                />
              )
            }
          } else if (userRole === MocUserRole?.CENTER_ADMIN) {
            if (
              // @ts-ignore
              cell?.row?.original?.centers?.length === 1 &&
              cell?.row?.original?.centers[0]?.centerId ===
                userDetail?.currentCenter?.centerId
            ) {
              return null
            } else {
              // @ts-ignore
              return (
                <img
                  className="eye-icon"
                  src={"assets/images/CRdelete.svg"}
                  width={32}
                  height={30}
                  style={{
                    marginTop: "6px",
                    paddingRight: "15px",
                    width: "40px",
                    height: "40px",
                  }}
                  alt="eye"
                />
              )
            }
          } else if (
            // @ts-ignore
            cell?.row?.original?.primaryRole === "SYSTEM_ADMIN"
          ) {
            return null
          } else {
            return (
              <img
                className="eye-icon"
                src={"assets/images/CRdelete.svg"}
                width={32}
                height={30}
                style={{
                  marginTop: "6px",
                  paddingRight: "15px",
                  width: "40px",
                  height: "40px",
                }}
                alt="eye"
              />
            )
          }
        }
      },
    },
  ]

  const columns = useMemo(() => COLUMNS, [])

  useEffect(() => {
    if (userRole === MocUserRole?.CENTER_ADMIN) {
      getAllManageStaffDetailsByCenterId(userDetail?.currentCenter?.centerId)
        .then((res) => {
          setData(res)
          // @ts-ignore
        })
        .catch((err) => {
          console.log("err", err)
        })
    } else if (
      userRole === MocUserRole?.SYSTEM_ADMIN ||
      userRole === MocUserRole?.OPERATIONS
    ) {
      getAllManageStaffDetails()
        .then((res) => {
          setData(res)
          // @ts-ignore
        })
        .catch((err) => {
          console.log("err", err)
        })
    }
  }, [])

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },

    useGlobalFilter,
    useSortBy
  )
  const { globalFilter } = state
  /**
   * @param {any} path
   */
  const redirectTo = async (path) => {
    history.push({
      pathname: "/editManageStaff",
      state: { idValue: path },
    })
  }
  // @ts-ignore
  const handleDelete = (path) => {
    // @ts-ignore
    // setIsLoading(true)
    if (userRole === MocUserRole?.SYSTEM_ADMIN) {
      deleteManageStaff(`${path}`)
        // @ts-ignore
        .then((res) => {
          setIsLoading(false)
          // @ts-ignore
          toggleDisplayToast({
            text: "Staff has been successfully deleted",
            type: "success",
          })
          getAllManageStaffDetails()
            .then((res) => {
              setData(res)
              // @ts-ignore
              setIsLoading(false)
              // @ts-ignore
            })
            .catch((err) => {
              console.log("err", err)
              setIsLoading(false)
            })
        })
        .catch((err) => {
          console.log("err", err)
          // @ts-ignore
          toggleDisplayToast({ text: "Failed to delete staff", type: "error" })
          setIsLoading(false)
        })
    } else if (userRole === MocUserRole?.CENTER_ADMIN) {
      // @ts-ignore
      const user = data?.find((each) => each?.id === path)
      if (user) {
        // @ts-ignore
        const updatedCenters = user?.centers?.filter(
          (/** @type {{ centerId: any; }} */ c) =>
            c?.centerId !== userDetail?.currentCenter?.centerId
        )
        // @ts-ignore
        const temp = { ...user }
        temp["centers"] = updatedCenters
        delete temp["mocConsultantId"]
        if (updatedCenters?.length > 0) {
          // @ts-ignore
          updateManageStaff(temp?.id, temp)
            // @ts-ignore
            .then((res) => {
              setIsLoading(false)
              // @ts-ignore
              toggleDisplayToast({
                text: "Staff has been successfully deleted",
                type: "success",
              })
              getAllManageStaffDetailsByCenterId(
                userDetail?.currentCenter?.centerId
              )
                .then((res) => {
                  setData(res)
                  // @ts-ignore
                  setIsLoading(false)
                })
                .catch((err) => {
                  console.log("err", err)
                  // @ts-ignore
                  setIsLoading(false)
                })
            })
            // @ts-ignore
            .catch((err) => {
              console.log("err", err)
              setIsLoading(false)
              // @ts-ignore
              toggleDisplayToast({
                text: "Failed to delete staff",
                type: "error",
              })
            })
        }
      }
    }
  }

  return (
    <div className="manage-staff-patients-container">
      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "50%",
          }}
        >
          <div
            style={{ width: "3rem", height: "3rem" }}
            className="spinner-border text-primary"
          ></div>
        </div>
      )}
      <div className="manage-staff-patients-heading">
        <div
          className="approval-back-image"
          onClick={() => {
            history.push("/home")
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"
          />
        </div>

        <div className="manage-staff-text">Staff Management</div>
      </div>

      <div className="manage-patients-container">
        <div className="manage-patients-container">
          <div className="row add-new">
            <div className="add-new-text">
              <div className="search-container">
                <div>
                  <GlobalFilter
                    filter={globalFilter}
                    setFilter={setGlobalFilter}
                  />
                </div>
              </div>
              <Button
                className={`button-container ${readOnlys ? "read-only" : ""}`}
                disabled={readOnlys}
                onClick={() => history.push(`/addManageStaff`)}
              >
                Add New Staff
              </Button>
            </div>
            <div>
              <table
                {...getTableProps()}
                // @ts-ignore
                ref={componentRef}
              >
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th {...column.getHeaderProps()}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              // paddingLeft: "40px",
                            }}
                          >
                            {column.render("Header")}
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody
                  className="border-radiusImportant"
                  {...getTableBodyProps()}
                >
                  {rows.map((row) => {
                    prepareRow(row)
                    return (
                      <tr {...row.getRowProps()} style={{ cursor: "pointer" }}>
                        {row.cells.map((cell) => {
                          return (
                            <td
                              onClick={() => {
                                if (readOnlys) return null
                                {
                                  if (
                                    cell?.column?.id?.toLowerCase() === "edit"
                                  ) {
                                    if (
                                      userRole === MocUserRole?.SYSTEM_ADMIN
                                    ) {
                                      // @ts-ignore
                                      redirectTo(row?.original?.id)
                                    } else {
                                      if (
                                        // @ts-ignore
                                        cell?.row?.original?.primaryRole ===
                                        "SYSTEM_ADMIN"
                                      ) {
                                      } else {
                                        // @ts-ignore
                                        redirectTo(row?.original?.id)
                                      }
                                    }
                                  }
                                  if (
                                    cell?.column?.id?.toLowerCase() === "delete"
                                  ) {
                                    if (
                                      userRole === MocUserRole?.SYSTEM_ADMIN
                                    ) {
                                      if (
                                        // @ts-ignore
                                        cell?.row?.original?.primaryRole ===
                                        "SYSTEM_ADMIN"
                                      ) {
                                      } else {
                                        toggleDisplayToast({
                                          // @ts-ignore
                                          text: `Are you sure you want to delete the staff?`,
                                          type: "warning",
                                          onClickText: "Yes",
                                          // @ts-ignore
                                          patient: cell?.row?.original?.id,
                                        })
                                      }
                                    } else {
                                      if (
                                        // @ts-ignore
                                        cell?.row?.original?.primaryRole ===
                                        "SYSTEM_ADMIN"
                                      ) {
                                      } else {
                                        // @ts-ignore
                                        {
                                          toggleDisplayToast({
                                            // @ts-ignore
                                            text: `Are you sure you want to delete the staff?`,
                                            type: "warning",
                                            onClickText: "Yes",
                                            // @ts-ignore
                                            patient: cell?.row?.original?.id,
                                          })
                                        }
                                      }
                                    }
                                  }
                                }
                              }}
                              style={{
                                maxWidth: "300px",
                                // width: "400px",
                                wordWrap: "break-word",
                                maxHeight: "100px",
                                // paddingLeft: "40px",
                                // verticalAlign: "left",
                                textAlign: "center",
                                // whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis !important",
                                fontSize: "18px",
                                lineHeight: "24px",
                                letterSpacing: "1.35px",
                                // textAlign: "initial",
                              }}
                              {...cell.getCellProps()}
                            >
                              {cell.render("Cell")}
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tbody>
                <tfoot>
                  {footerGroups.map((footerGroup) => (
                    <tr {...footerGroup.getFooterGroupProps()}>
                      {footerGroup.headers.map((column) => (
                        <td {...column.getFooterProps()}>
                          {column.render("Footer")}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tfoot>
              </table>
            </div>
          </div>
        </div>
        {displayToast && (
          <Toast
            // @ts-ignore
            textMessage={displayToast?.text}
            // @ts-ignore
            onClose={() => toggleDisplayToast(false)}
            onCloseText="Close"
            onClickText={
              // @ts-ignore
              displayToast?.onClickText ? displayToast?.onClickText : null
            }
            onClick={() =>
              // @ts-ignore
              displayToast?.patient
                ? // @ts-ignore
                  handleDelete(displayToast?.patient)
                : null
            }
            // @ts-ignore
            type={displayToast?.type}
          />
        )}
      </div>
    </div>
  )
}
export default ManageStaff
